import { Map } from "ol";
import BaseLayer from "ol/layer/Base";
import VectorLayer from "ol/layer/Vector";
import { Cluster } from "ol/source";
import { flattenMapLayers } from "~/utils/flattenMapLayers";
import { MapItem } from "../types/mapItems";

export function findLayerByFeatureId(
  map: Map,
  featureMapId?: MapItem["mapId"],
): BaseLayer | null {
  const layers = flattenMapLayers(map);
  if (!featureMapId) return null;

  for (let i = 0; i < layers.length; i++) {
    const l = layers[i];
    if (l instanceof VectorLayer) {
      const source = l.getSource();
      if (source instanceof Cluster) {
        const feat = source.getSource().getFeatureById(featureMapId);
        if (feat) return l;
      } else {
        const feat = source.getFeatureById(featureMapId);
        if (feat) return l;
      }
    }
  }

  return null;
}
